/**
 * 할일 체크리스트(/todo/).
 *
 * 체크박스를 누르면 바로 저장한다(옵션). 실패하면 되돌리고 안내한다.
 * "마크다운 복사"는 서버가 체크를 합쳐 둔 원문(textarea)을 화면의 현재 체크 상태로
 * 한 번 더 맞춘 뒤 클립보드에 넣는다 — 끝난 항목은 화면에서 "완료" 로 옮겨져 순서가 원문과
 * 다르므로, 항목의 data-todo-index(원문에서 몇 번째 체크 줄인지)로 맞춘다.
 */

const CHECK_LINE = /^(\s*- \[)[ xX](\] .+)$/;

const postAjax = async (root, action, data) => {
  const body = new URLSearchParams({ action, nonce: root.dataset.nonce, ...data });
  const response = await fetch(root.dataset.ajaxUrl, {
    method: 'POST',
    body,
    credentials: 'same-origin',
  });
  const json = await response.json().catch(() => null);

  if (!json || !json.success) {
    throw new Error(json?.data?.message || `요청 실패 (HTTP ${response.status})`);
  }

  return json.data;
};

const copyText = async (text) => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const helper = document.createElement('textarea');
  helper.value = text;
  helper.setAttribute('readonly', '');
  helper.style.position = 'fixed';
  helper.style.opacity = '0';
  document.body.appendChild(helper);
  helper.select();
  document.execCommand('copy');
  helper.remove();
};

const InitTodo = () => {
  const root = document.querySelector('[data-qrshop-todo]');

  if (!root) {
    return;
  }

  const notice = root.querySelector('[data-todo-notice]');
  const noticeText = root.querySelector('[data-todo-notice-text]');
  const doneCount = root.querySelector('[data-todo-done]');
  const totalCount = root.querySelector('[data-todo-total]');
  const source = root.querySelector('[data-todo-source]');
  let noticeTimer = 0;

  const setNotice = (message, type = 'success') => {
    if (!notice) {
      return;
    }

    window.clearTimeout(noticeTimer);
    notice.classList.remove('notice--success', 'notice--error');
    notice.classList.add(`notice--${type}`);
    noticeText.textContent = message;
    notice.hidden = false;
    noticeTimer = window.setTimeout(() => {
      notice.hidden = true;
    }, 2500);
  };

  const mergedMarkdown = () => {
    const checks = new Map(
      [...root.querySelectorAll('[data-todo-item]')].map((item) => [
        Number(item.dataset.todoIndex),
        item.querySelector('input[type="checkbox"]'),
      ]),
    );
    let i = 0;

    return (source?.value ?? '')
      .split('\n')
      .map((line) => {
        const match = line.match(CHECK_LINE);

        if (!match) {
          return line;
        }

        const done = checks.get(i)?.checked ?? line.includes('[x]');
        i += 1;

        return `${match[1]}${done ? 'x' : ' '}${match[2]}`;
      })
      .join('\n');
  };

  root.addEventListener('change', async (event) => {
    const input = event.target;
    const item = input.closest?.('[data-todo-item]');

    if (!item || input.type !== 'checkbox') {
      return;
    }

    const done = input.checked;
    item.classList.add('is-saving');
    item.classList.toggle('todo__item--done', done);

    try {
      const data = await postAjax(root, 'qrshop_todo_toggle', {
        id: item.dataset.todoItem,
        done: done ? '1' : '0',
      });

      doneCount.textContent = String(data.completed);
      totalCount.textContent = String(data.total);
    } catch (error) {
      input.checked = !done;
      item.classList.toggle('todo__item--done', !done);
      setNotice(error.message || '저장하지 못했습니다.', 'error');
    } finally {
      item.classList.remove('is-saving');
    }
  });

  root.querySelector('[data-todo-copy]')?.addEventListener('click', async () => {
    try {
      await copyText(mergedMarkdown());
      setNotice('마크다운을 복사했습니다. 로컬 TODO.md 에 붙여 넣으세요.');
    } catch {
      setNotice('복사하지 못했습니다.', 'error');
    }
  });
};

export default InitTodo;
